<template>
    <div>
        <b-form>
            <b-form-group id="input-group-1" :label="$t('document_form.document_name')" label-for="input-1">
                <b-form-input :disabled="false" id="input-1" v-model="form.name" required
                    :placeholder="$t('document_form.document_name')" />
            </b-form-group>
            <b-form-group :label="$t('document_form.file')" label-for="file-small" label-cols-sm="2">
                <b-form-file v-model="documentFile" :disabled="false" id="file-small" :browse-text="$t('file.browse')"
                    :placeholder="existingFilename || $t('file.no_file')" />
            </b-form-group>
        </b-form>
    </div>
</template>

<script>
import documents from '@/store/documents/documents';

export default {
    name: 'DocumentEditForm',
    components: {},
    props: {
        editordata: Object,
        creatingNew: Boolean,
    },
    data() {
        return {
            form: {},
            documentFile: null,
            existingFilename: null,
            defaultFormData: {
                id: -1,
                name: '',
                documentOptionJsonMsg: {
                    id: -1,
                    destinations: [],
                    validityBegins: null,
                    validityEnds: null
                },
                documentToken: null
            }
        };
    },
    beforeCreate() {
        if (!this.$store.state.documents) {
            this.$store.registerModule('documents', documents);
        }
    },
    created() {
        if (this.editordata != null) {
            this.form = JSON.parse(JSON.stringify(this.toFormData(this.editordata)));
            this.existingFilename = this.editordata.documentMetadata?.filename || null;
        } else {
            this.form = JSON.parse(JSON.stringify(this.defaultFormData));
        }
    },
    computed: {
        documentToken() {
            return this.$store.getters['documents/documentToken'];
        }
    },
    watch: {
        editordata() {
            if (this.editordata == null) {
                this.resetForm();
            } else {
                this.form = JSON.parse(JSON.stringify(this.toFormData(this.editordata)));
                this.existingFilename = this.editordata.documentMetadata?.filename || null;
                this.disabled = false;
            }
        },
        creatingNew() {
            if (this.creatingNew) {
                this.newDocument();
            }
        },
        documentFile(newFile) {
            if (newFile == null) {
                this.form.documentToken = null;
                this.$store.commit('documents/clearDocumentToken');
                return;
            }
            this.$store.dispatch('documents/sendDocument', this.documentFile).catch(() => {
                this.$travellerGetDataError();
            });
        },
        documentToken(newToken) {
            this.form.documentToken = newToken;
        },
        'form.name'(newName) {
            this.form.name = newName;
        }
    },
    methods: {
        newDocument() {
            this.form = JSON.parse(JSON.stringify(this.defaultFormData));
            this.documentFile = null;
            this.existingFilename = null;
            this.disabled = false;
            this.$store.commit('documents/clearDocumentToken');
        },
        resetForm() {
            this.form = JSON.parse(JSON.stringify(this.defaultFormData));
            this.documentFile = null;
            this.existingFilename = null;
            this.disabled = false;
            this.$store.commit('documents/clearDocumentToken');
        },
        collectFormData() {
            return JSON.parse(JSON.stringify(this.form));
        },
        toFormData(receivedData) {
            let form = JSON.parse(JSON.stringify(this.defaultFormData));
            if (receivedData && receivedData.documentMetadata) {
                form.id = receivedData.documentMetadata.id;
                form.name = receivedData.documentMetadata.name;
                form.documentOptionJsonMsg.id = receivedData.id;
                form.documentOptionJsonMsg.destinations = receivedData.destinations;
                form.documentOptionJsonMsg.validityBegins = receivedData.validity_begins;
                form.documentOptionJsonMsg.validityEnds = receivedData.validity_ends;
                return form;
            }
            return receivedData;
        }
    }
};
</script>
